/*eslint-disable */
'use strict';

function getUseCaseCategoriesTextKey(usecases, text_key) {
  for (const cat of usecases) {
    const bo = cat.sub_categories.find(sub => {
      return sub.text_key === text_key;
    });

    if (bo) {
      return {
        category: cat.category.text_key,
        sub_category: bo.text_key,
      };
    }

    if (!bo) {
      if (text_key === cat.category.text_key) {
        return {
          category: cat.category.text_key,
          sub_category: null,
        };
      }
    }
  }
}

function translateUseCase(textKey) {
  if (!textKey) {
    return null;
  }

  const langCode = window.LANGUAGE_CODE || 'en';
  const trans = window.TRANSLATIONS;

  return trans?.[textKey]?.[`text_${langCode}`] || trans?.[textKey]?.[`text_en`] || textKey;
}

function getUseCaseCodeByTextKey(usecases, textKey) {
  for (const cat of usecases) {
    const bo = cat.sub_categories.find(sub => {
      return sub.text_key === textKey;
    });

    if (bo) {
      return bo.code;
    }
  }

  return null;
}

$(function() {
  var P = require('./main.js');
  var stateValidation = function() {
    P.rh_state_field(
      $('.bootbox #js-createorganizationform #id_country_code'),
      $('.bootbox #js-createorganizationform #id_state'),
    );
  };

  if ($('.creation-organization-form').length > 0) {
    P.rh_state_field(
      $('.creation-organization-form #js-createorganizationform #id_country_code'),
      $('.creation-organization-form #js-createorganizationform #id_state'),
    );
  }

  var truncateString = function(title, num) {
    if (title.length < num) return title;
    return (
      jQuery
        .trim(title)
        .substring(0, num - 4)
        .trim(this) + '...'
    );
  };

  new P.ModalConfirm({
    path: function() {
      return this._clicked.data('user-id') + '/active/';
    },
    title: gettext('Disable User'),
    message: gettext('Are you sure you want to change this user status?'),
    triggerElement: $('.js-user-status'),
    buttons: {
      confirm: {
        label: gettext('CONFIRM'),
        className: 'btn-primary pull-left btn-lg btn',
      },
    },
    onSuccessSubmit: function() {
      var row = this._clicked.parents('tr');
      row.toggleClass('inactive');
      row.find('.dropdown-menu li:lt(2)').toggleClass('hidden');
      if (this._clicked.data('active') == 'True') {
        row.find('td input:checkbox').attr('disabled', true);
        this._clicked.text(gettext('Enable'));
        this._clicked.data('active', 'False');
      } else {
        row.find('td input:checkbox').removeAttr('disabled');
        this._clicked.text(gettext('Disable'));
        this._clicked.data('active', 'True');
      }
    },
  });
  new P.ModalConfirm({
    path: function() {
      return this._clicked.data('user-id') + '/roles/';
    },
    title: gettext('Change Admin'),
    message: gettext('Are you sure you want to change this user role?'),
    triggerElement: $('.js-user-admin'),
    buttons: {
      confirm: {
        label: gettext('CHANGE'),
        className: 'btn-primary btn btn-lg pull-left',
      },
    },
    onCancel: function() {
      if (!this._clicked.is(':checked')) this._clicked.prop('checked', 'checked');
      else this._clicked.prop('checked', '');
    },
  });
  new P.ModalConfirm({
    path: function() {
      return this._clicked.data('user-id') + '/remove/';
    },
    title: gettext('Remove user'),
    message: gettext('Are you sure you want to permanently remove this user ?'),
    triggerElement: $('.js-remove-user'),
    onSuccessSubmit: function() {
      var users_table = $('.s-table');
      users_table.find(this._clicked.parents('tr')).remove();
    },
  });

  new P.ModalConfirm({
    path: function() {
      return this._clicked.data('invite-id') + '/remove_invite/';
    },
    title: gettext('Remove user'),
    message: gettext('Are you sure you want to permanently remove this invitation ?'),
    triggerElement: $('.js-remove-invite-user'),
    onSuccessSubmit: function() {
      var users_table = $('.s-table');
      users_table.find(this._clicked.parents('tr')).remove();
    },
  });

  new P.ModalConfirm({
    path: function() {
      return this._clicked.data('invite-id') + '/resend_invite/';
    },
    buttons: {
      confirm: {
        label: gettext('Resend'),
        className: 'btn-primary btn btn-lg pull-left',
      },
    },
    title: gettext('Resend Invitation'),
    message: gettext('Are you sure you want to resend invitation ?'),
    triggerElement: $('.js-resend-invite-user'),
    onSuccessSubmit: function() {
      window.location.reload();
    },
  });

  new P.ModalConfirm({
    path: function() {
      return 'toggleAuth2/' + this._clicked.data('org-id');
    },
    title: gettext('Login with Google'),
    message: function() {
      if (this._clicked.is(':checked')) {
        return gettext(
          'After activating this feature, users will only be allowed to login using a Gmail or G Suite email address.\n' +
            'Don’t forget to update your existing user list, if you haven’t already, to ensure all users have Google email addresses.\n',
        );
      }

      return gettext('Removing google from the sole sign in will let the users login with password');
    },
    triggerElement: $('.js-enforce-auth2'),
    buttons: {
      confirm: {
        label: gettext('Confirm'),
        className: 'btn-primary btn btn-lg pull-left',
      },
    },
    onCancel: function() {
      if (!this._clicked.is(':checked')) this._clicked.prop('checked', 'checked');
      else this._clicked.prop('checked', '');
    },
  });

  (function() {
    var basePath = '/accounts';

    const isModalOpenedFromBilling = () => {
      return $('#add-cc-button[data-has-org-address=False], #change-cc-button[data-has-org-address=False]').length;
    };

    if (typeof DEV_MODE !== 'undefined' && DEV_MODE) {
      basePath = '';
    }

    //Using Separate namespace to avoid name clash
    var orgPath = basePath + '/organization/create/';
    var orgTrigger = $(
      '#create-org-button, #change-cc-button[data-has-org-address=False], #add-cc-button[data-has-org-address=False]',
    );
    var title = gettext('Organization Details');
    var onSuccessSubmit = function(form) {
      if (isModalOpenedFromBilling()) {
        P.orgAddress = {};
        $.each(['address', 'city', 'postal_code'], function(i, field) {
          var newVal = form.find('#id_' + field).val();
          P.orgAddress[field] = newVal;
        });

        P.orgAddress['country_code'] = form.find('#id_country_code option:selected').val();
        P.orgAddress['state'] = form.find('#id_state option:selected').val();

        // Updating that this org has addressjs-createorganizationform
        //$('#add-cc-button[data-has-org-address=False]').attr('data-has-org-address', 'True');
        P.addNewCardForm.init();
        P.addNewCardForm.start();
      } else {
        window.location.reload();
      }
    };
    if ($('#js-btn-edit-org').length > 0) {
      orgPath = 'edit/';
      orgTrigger = $('#js-btn-edit-org');
      title = gettext('Edit Organization');
      onSuccessSubmit = function(form) {
        var prev = null;
        $.each(['name', 'invoice_email', 'phone', 'address', 'city', 'postal_code', 'vat_id'], function(i, field) {
          var new_val = form.find('#id_' + field).val();
          var $fieldDiv = $('#org_' + field);
          if ($fieldDiv.length > 0) {
            $fieldDiv.text(new_val);
            if (new_val == '') {
              $fieldDiv.parent().addClass('hide');
            } else {
              $fieldDiv.parent().removeClass('hide');
            }
          }
          prev = $fieldDiv;
        });

        var text = form.find('#id_country_code option:selected').text();
        $('#org_country')
          .text(text)
          .parent()
          .toggle(text != 'Select Country');

        text = form.find('#id_state option:selected').text();
        $('#org_state')
          .text(text)
          .parent()
          .toggle(text != 'Select State');

        if (window.CURRENT_USE_CASE && window.CAN_EDIT_USE_CASE) {
          if (!window.CURRENT_USE_CASE || window.CURRENT_USE_CASE === 'null') {
            $('#select-other-use-case-no-value').removeClass('hide');

            $('#org_vetting_use_case')
              .parent()
              .addClass('hide');

            return;
          }

          if (window.CURRENT_USE_CASE === 'PERSONAL') {
            $('#select-other-use-case-no-value').addClass('hide');
            $('#org_vetting_use_case').show();
            $('#org_vetting_use_case').text(window.CURRENT_USE_CASE_CATEGORY_SNAP);
            $('#org_vetting_use_case')
              .parent()
              .removeClass('hide');
          } else if (window.CURRENT_USE_CASE === 'OTHER') {
            $('#select-other-use-case-no-value').addClass('hide');
            $('#org_vetting_use_case').show();
            $('#org_vetting_use_case').text(window.CURRENT_USE_SUB_CASE_CATEGORY_SNAP);
            $('#org_vetting_use_case')
              .parent()
              .removeClass('hide');
          } else {
            $('#select-other-use-case-no-value').addClass('hide');
            $('#org_vetting_use_case').show();
            $('#org_vetting_use_case').text(
              `${window.CURRENT_USE_CASE_CATEGORY_SNAP} - ${window.CURRENT_USE_SUB_CASE_CATEGORY_SNAP}`,
            );
            $('#org_vetting_use_case')
              .parent()
              .removeClass('hide');
          }
        }
      };
    }

    new P.ModalForm({
      fixData: data => {
        if (!window.USE_CASES) {
          return data;
        }

        const params = new URLSearchParams(data);

        const categoryUseCaseValue = document.getElementById('id_vetting_use_case').value;
        const current = USE_CASES.find(item => {
          return item.category.id == categoryUseCaseValue;
        });

        if (!current) {
          let index = data.indexOf('vetting');

          if (index < 0) {
            return data;
          }

          window.CURRENT_USE_CASE = 'null';
          window.CURRENT_USE_CASE_CATEGORY = 'null';
          window.CURRENT_USE_SUB_CASE_CATEGORY = 'null';

          return data.substring(0, index);
        }

        let textKey = params.get('vetting_sub_use_case');
        let otherText = params.get('vetting_other_use_case', '');
        let selectedId = getUseCaseCodeByTextKey(window.USE_CASES, textKey);
        let categoryTexts = getUseCaseCategoriesTextKey(window.USE_CASES, textKey);
        let other = false;

        if (current.category.code === 'OTHER' || current.category.code === 'PERSONAL') {
          selectedId = current.category.code;

          if (current.category.code === 'OTHER') {
            other = true;
          }

          categoryTexts = {
            sub_category: null,
            category: selectedId,
          };
        }

        let index = data.indexOf('vetting');
        if (index < 0) {
          return data;
        }

        let fixed = data.substring(0, index);

        if (window.CAN_EDIT_USE_CASE) {
          $('#id_vetting_use_case_sub_category_text_snapshot-error').remove();

          window.CURRENT_USE_CASE = selectedId;
          window.CURRENT_USE_CASE_CATEGORY = categoryTexts.category;
          window.CURRENT_USE_SUB_CASE_CATEGORY = categoryTexts.sub_category;

          if (other) {
            window.CURRENT_USE_SUB_CASE_CATEGORY_SNAP = otherText.trim();
          } else {
            window.CURRENT_USE_CASE_CATEGORY_SNAP = translateUseCase(categoryTexts.category);
            window.CURRENT_USE_SUB_CASE_CATEGORY_SNAP = translateUseCase(categoryTexts.sub_category);
          }

          let url =
            fixed +
            `&vetting_use_case=${window.CURRENT_USE_CASE}&vetting_use_case_category_text=${
              categoryTexts.category
            }&vetting_use_case_category_text_snapshot=${translateUseCase(categoryTexts.category)}${
              categoryTexts.sub_category ? `&vetting_use_case_sub_category_text=${categoryTexts.sub_category}` : ''
            }${
              categoryTexts.sub_category || other
                ? `&vetting_use_case_sub_category_text_snapshot=${translateUseCase(categoryTexts.sub_category) ||
                    otherText}`
                : ''
            }`;

          return url;
        }
      },
      path: orgPath,
      title: title,
      triggerElement: orgTrigger,
      formContainer: window.USE_CASES ? $('#js-createorganizationform') : $('#js-createorganizationformnovetting'),
      onSuccessSubmit: onSuccessSubmit,
      onModalActive: function() {
        stateValidation();

        if (!window.USE_CASES) {
          return;
        }

        const use_case_select = window.document.getElementById('id_vetting_use_case');
        const usedCases = window.USE_CASES;

        const firstOption = document.createElement('option');
        firstOption.setAttribute('value', null);
        firstOption.append('Select Value');

        const options = usedCases.map((cat, i) => {
          const op = document.createElement('option');
          op.setAttribute('value', cat.category.id);
          op.append(translateUseCase(cat.category.text_key));

          return op;
        });

        if (!$('#div_id_vetting_sub_use_case').length) {
          const subUseCaseDIV = $('#div_id_vetting_use_case').clone(true);
          const otherSubUseCase = $('#div_id_vat_id').clone(true);

          otherSubUseCase.attr('id', 'div_id_vetting_other_use_case');
          subUseCaseDIV.attr('id', 'div_id_vetting_sub_use_case');

          $(otherSubUseCase)
            .find('input')
            .attr('id', 'id_vetting_other_use_case')
            .attr('name', 'vetting_other_use_case')
            .empty();

          $(otherSubUseCase).append(
            document.createElement('span', { id: 'vetting_use_case_sub_category_text_snapshot-error' }),
          );

          $(otherSubUseCase)
            .find('label')
            .text(gettext('Purpose of Use'));

          $('#js-createorganizationform').append(otherSubUseCase);

          if (window.CURRENT_USE_CASE === 'OTHER') {
            $(otherSubUseCase)
              .find('input')
              .attr('value', window.CURRENT_USE_SUB_CASE_CATEGORY_SNAP);
          } else {
            $(otherSubUseCase)
              .find('input')
              .attr('value', '');
            $(otherSubUseCase).hide();
          }

          $(subUseCaseDIV)
            .find('select')
            .attr('id', 'id_vetting_sub_use_case')
            .attr('name', 'vetting_sub_use_case')
            .empty();

          $(subUseCaseDIV)
            .find('label')
            .text(gettext('Purpose of Use'));

          $('#js-createorganizationform').append(subUseCaseDIV);
        }

        if (
          !window.CURRENT_USE_CASE ||
          window.CURRENT_USE_CASE === 'OTHER' ||
          window.CURRENT_USE_CASE === 'PERSONAL' ||
          window.CURRENT_USE_CASE === 'None' ||
          window.CURRENT_USE_CASE === 'null'
        ) {
          $('#div_id_vetting_sub_use_case').hide();
        }

        $(use_case_select).empty();
        $(use_case_select).change(function() {
          $('#div_id_vetting_other_use_case').hide();
          const subUseCaseDIV = $('#div_id_vetting_sub_use_case');
          const current = usedCases.find(item => {
            return item.category.id == this.value;
          });

          if (!current) {
            subUseCaseDIV.hide();
            return;
          }

          const sub = current.sub_categories;
          if (current.category.code === 'OTHER') {
            $('#div_id_vetting_other_use_case').show();
            subUseCaseDIV.hide();
            $('#div_id_vetting_other_use_case')
              .find('input')
              .empty();
            return;
          } else {
            $('#div_id_vetting_other_use_case').hide();
            $('#div_id_vetting_other_use_case')
              .find('input')
              .empty();
          }

          if (!sub || !sub.length) {
            subUseCaseDIV.hide();
            return;
          }
          subUseCaseDIV.show();

          const options = sub.map((cat, i) => {
            const op = document.createElement('option');

            op.setAttribute('value', cat.text_key);
            op.append(translateUseCase(cat.text_key));

            return op;
          });

          const subUseCaseSelect = $('#id_vetting_sub_use_case');
          subUseCaseSelect.empty();
          subUseCaseSelect.append(options);
        });

        $(use_case_select).append([firstOption, ...options]);

        const current = window.CURRENT_USE_CASE;
        let currentParent = null;
        let currentChildren = null;

        const categoryText = window.CURRENT_USE_CASE_CATEGORY;
        const categorySubText = window.CURRENT_USE_SUB_CASE_CATEGORY;

        for (const c of USE_CASES) {
          const bo = c.sub_categories.find(sub => {
            return sub.text_key === categorySubText;
          });

          if (!bo) {
            if (c.category.code === current) {
              currentParent = c.category.id;
              break;
            }
          } else {
            const options = c.sub_categories.map((cat, i) => {
              const op = document.createElement('option');

              op.setAttribute('value', cat.text_key);
              op.append(translateUseCase(cat.text_key));

              return op;
            });

            const subUseCaseSelect = $('#id_vetting_sub_use_case');
            subUseCaseSelect.empty();
            subUseCaseSelect.append(options);

            currentParent = c.category.id;
            currentChildren = bo.text_key;
            break;
          }
        }

        const parentSelect = document.getElementById('id_vetting_use_case');
        const childrenSelect = document.getElementById('id_vetting_sub_use_case');

        parentSelect.value = currentParent;
        childrenSelect.value = currentChildren;

        if (!window.CAN_EDIT_USE_CASE) {
          childrenSelect.disabled = true;
          parentSelect.disabled = true;

          document.getElementById('id_vetting_use_case_category_text').disabled = true;
          document.getElementById('id_vetting_use_case_sub_category_text').disabled = true;

          document.getElementById('id_vetting_use_case_sub_category_text_snapshot').disabled = true;
          document.getElementById('id_vetting_use_case_category_text_snapshot').disabled = true;
          document.getElementById('id_vetting_other_use_case').disabled = true;
        }

        if (window.CURRENT_USE_CASE === 'OTHER' || window.CURRENT_USE_CASE === 'PERSONAL') {
          $('#div_id_vetting_sub_use_case').hide();
        }
      },
      validatorConfig: {
        rules: {
          name: {
            required: true,
            minlengthtrim: 1,
          },
          invoice_email: {
            required: true,
            email: true,
          },
          phone: {
            minlengthtrim: 6,
          },
          address: {
            required: true,
            minlengthtrim: 2,
          },
          city: {
            required: true,
            minlengthtrim: 2,
          },
          country_code: {
            required: true,
            depend: '#js-createorganizationform #id_state',
          },
          state: {
            required: {
              depends: function() {
                if (
                  $('.bootbox #js-createorganizationform #id_country_code').val() == 'US' ||
                  $('.bootbox #js-createorganizationform #id_country_code').val() == 'CA'
                ) {
                  return true;
                }
                return false;
              },
            },
            requiredonly: true,
          },
          postal_code: {
            required: true,
            minlength: 3,
          },
          vat_id: {
            required: false,
          },
        },
        messages: {
          name: {
            required: gettext('Organization name is required'),
          },
          invoice_email: {
            required: gettext('Organization email is required'),
            email: gettext('Email is invalid'),
          },
          phone: {
            minlength: gettext('Invalid phone number'),
          },
          country_code: {
            required: gettext('Country is required'),
            depend: gettext('Please enter a State'),
          },
          address: {
            required: gettext('Address is required'),
          },
          city: {
            required: gettext('City is required'),
          },
          state: {
            required: gettext('State is required'),
          },
          postal_code: {
            required: gettext('Zip code is required'),
            minlength: gettext('Invalid zip code'),
          },
        },
      },
    });
  })();

  new P.ModalForm({
    path: function() {
      return this._clicked.data('user-id') + '/profile/';
    },
    title: gettext('Update Profile'),
    triggerElement: $('.js-user-edit'),
    onSuccessSubmit: function(form, data) {
      var row = $('.s-table').find('tr[data-user-id=' + this._clicked.data('user-id') + ']');
      var full_name =
        this.options.formContainer.find('#id_first_name').val() +
        ' ' +
        this.options.formContainer.find('#id_last_name').val();
      var email = this.options.formContainer.find('#id_email').val();
      var link = $('<a></a>');

      link.attr('href', 'mailto:' + full_name + '<' + email + '>');
      link.text(truncateString(email, 29));

      row.find('td:eq(1)').html(link);
      row.find('td:eq(0)').text(truncateString(full_name, 29));
    },
    validatorConfig: {
      rules: {
        first_name: {
          required: true,
          minlengthtrim: 1,
        },
        last_name: {
          required: true,
          minlengthtrim: 1,
        },
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: gettext('Email is required'),
          email: gettext('Email is invalid'),
        },
        first_name: {
          required: gettext('First name is required'),
        },
        last_name: {
          required: gettext('Last name is required'),
        },
      },
    },
  });
  new P.ModalForm({
    path: function() {
      return this._clicked.data('user-id') + '/password/';
    },
    title: gettext('Reset password'),
    triggerElement: $('.js-user-reset'),
    formContainer: $('#js-resetuserpasswordform'),
    validatorConfig: {
      rules: {
        password: {
          required: true,
          minlength: 6,
        },
        password_confirm: {
          equalTo: '#js-resetuserpasswordform #id_password',
        },
      },
      messages: {
        password: {
          minlength: gettext('Password must be at least 6 characters'),
        },
        password_confirm: {
          equalTo: gettext('Please repeat the same password'),
        },
      },
    },
  });
  new P.ModalForm({
    path: 'create/',
    title: gettext('Create User'),
    triggerElement: $('#js-create-user'),
    formContainer: $('#js-creatememberform'),
    onSuccessSubmit: function() {
      window.location.reload();
    },
    onModalActive: function() {
      this._modal.find('#id_first_name').focus();

      $('#id_email').on('blur', function(e) {
        const data = {
          email: e.target.value,
        };

        function hideFormView() {
          $('#js-creatememberform')
            .find('#div_id_password')
            .hide();
          $('#js-creatememberform')
            .find('#div_id_password_confirm')
            .hide();
          $('#js-creatememberform')
            .find('#div_id_first_name')
            .hide();
          $('#js-creatememberform')
            .find('#div_id_last_name')
            .hide();
        }

        function showFormView() {
          $('#js-creatememberform')
            .find('#div_id_password')
            .show();
          $('#js-creatememberform')
            .find('#div_id_password_confirm')
            .show();
          $('#js-creatememberform')
            .find('#div_id_first_name')
            .show();
          $('#js-creatememberform')
            .find('#div_id_last_name')
            .show();
        }

        var basePath = '/accounts';

        if (typeof DEV_MODE !== 'undefined' && DEV_MODE) {
          basePath = '';
        }

        $.post(`${basePath}/api/onboard/is_inviteable_email`, data)
          .done(isInviteable => {
            if (isInviteable) {
              hideFormView();
            } else {
              showFormView();
            }
          })
          .fail(error => {
            showFormView();
          });
      });
    },
    validatorConfig: {
      rules: {
        first_name: {
          required: true,
          minlengthtrim: 1,
        },
        last_name: {
          required: true,
          minlengthtrim: 1,
        },
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
          minlengthtrim: 6,
        },
        password_confirm: {
          equalTo: '#js-creatememberform #id_password',
        },
      },
      messages: {
        email: {
          required: gettext('Email is required'),
          email: gettext('Email is invalid'),
        },
        first_name: {
          required: gettext('First name is required'),
        },
        last_name: {
          required: gettext('Last name is required'),
        },
        password: {
          required: gettext('Password is required'),
          minlength: gettext('Password must be at least 6 characters'),
        },
        password_confirm: {
          equalTo: gettext('Please repeat the same password'),
        },
      },
    },
  });
});
